export default __webpack_public_path__ + "static/media/profileImage.d353428c.jpg";